export default __webpack_public_path__ + "static/media/035-packages.b12b3daa.png";